/**
 * Language keys on angular format
 */
export enum LanguageEnum {
  PT_BR = "pt-BR",
  ES = "es",
  EN_US = "en-US",
  DE_DE = "de-DE",
  PT_PT = "pt-PT",
  ES_ES = "es-ES",
  EN_EN = "en-EN"
}

/**
 * Language keys on Keycloak format
 */
export enum LanguageKeycloakEnum {
  PT_BR = "pt-BR",
  ES = "es",
  EN_US = "en",
  DE_DE = "de",
  PT_PT = "pt-PT",
  ES_ES = "es-ES",
  EN_EN = "en-EN"
}

export function angularToKeycloakCode(code: LanguageEnum) {
  const keycloakCode = {
    [LanguageEnum.PT_BR]: LanguageKeycloakEnum.PT_BR,
    [LanguageEnum.ES]: LanguageKeycloakEnum.ES,
    [LanguageEnum.EN_US]: LanguageKeycloakEnum.EN_US,
    [LanguageEnum.DE_DE]: LanguageKeycloakEnum.DE_DE,
    [LanguageEnum.PT_PT]: LanguageKeycloakEnum.PT_BR,
    [LanguageEnum.ES_ES]: LanguageKeycloakEnum.ES,
    [LanguageEnum.EN_EN]: LanguageKeycloakEnum.EN_US
  };

  return keycloakCode[code] || LanguageKeycloakEnum.PT_BR;
}

export function keycloakToAngularCode(code: LanguageKeycloakEnum) {
  const angularCode = {
    [LanguageKeycloakEnum.PT_BR]: LanguageEnum.PT_BR,
    [LanguageKeycloakEnum.ES]: LanguageEnum.ES,
    [LanguageKeycloakEnum.EN_US]: LanguageEnum.EN_US,
    [LanguageKeycloakEnum.DE_DE]: LanguageEnum.DE_DE,
    [LanguageKeycloakEnum.PT_PT]: LanguageEnum.PT_BR,
    [LanguageKeycloakEnum.ES_ES]: LanguageEnum.ES,
    [LanguageKeycloakEnum.EN_EN]: LanguageEnum.EN_US
  };

  return angularCode[code] || LanguageEnum.PT_BR;
}

export function mapLanguageByPlatform(
  lang: LanguageEnum,
  isFleetality: boolean
): LanguageEnum {
  const fleetalityMapping = {
    [LanguageEnum.PT_BR]: LanguageEnum.PT_PT,
    [LanguageEnum.EN_US]: LanguageEnum.EN_EN,
    [LanguageEnum.ES]: LanguageEnum.ES_ES,
    [LanguageEnum.DE_DE]: LanguageEnum.DE_DE
  };

  const drivebMapping = {
    [LanguageEnum.PT_PT]: LanguageEnum.PT_BR,
    [LanguageEnum.EN_EN]: LanguageEnum.EN_US,
    [LanguageEnum.ES_ES]: LanguageEnum.ES,
    [LanguageEnum.DE_DE]: LanguageEnum.DE_DE
  };

  return isFleetality
    ? fleetalityMapping[lang] || lang
    : drivebMapping[lang] || lang;
}
